module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/milano.3ec4c42a2b5e03131af6a96ffc02ffb4.jpg";